import { ArrowDownCircle, ArrowUpCircle } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import type { CashMovement } from "@/hooks/useCashRegister";

interface CashMovementsListProps {
  movements: CashMovement[];
}

export function CashMovementsList({ movements }: CashMovementsListProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  return (
    <div className="space-y-2">
      {movements.map((movement) => {
        const isWithdrawal = movement.type === "withdrawal";
        const Icon = isWithdrawal ? ArrowUpCircle : ArrowDownCircle;
        const colorClass = isWithdrawal ? "text-red-600" : "text-green-600";
        const bgClass = isWithdrawal ? "bg-red-50 dark:bg-red-900/10" : "bg-green-50 dark:bg-green-900/10";

        return (
          <div
            key={movement.id}
            className={`flex items-center justify-between p-3 rounded-lg ${bgClass}`}
          >
            <div className="flex items-center gap-3">
              <Icon className={`h-5 w-5 ${colorClass}`} />
              <div>
                <p className="font-medium text-sm">
                  {isWithdrawal ? "Sangria" : "Suprimento"}
                </p>
                {movement.reason && (
                  <p className="text-xs text-muted-foreground">{movement.reason}</p>
                )}
                <p className="text-xs text-muted-foreground">
                  {format(new Date(movement.created_at), "dd/MM/yyyy HH:mm", { locale: ptBR })}
                </p>
              </div>
            </div>
            <span className={`text-lg font-bold ${colorClass}`}>
              {isWithdrawal ? "-" : "+"}{formatCurrency(Number(movement.amount))}
            </span>
          </div>
        );
      })}
    </div>
  );
}
